var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
// styles
import "./radioButton.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-radioButton",
    checked: false,
    size: "medium",
    color: "primary",
    errored: false,
    disabled: false,
    labelPosition: "right",
    type: undefined,
};
const RadioButton = (_a) => {
    var { onChange, checked, size, color, errored, disabled, label, labelPosition, className, type } = _a, rest = __rest(_a, ["onChange", "checked", "size", "color", "errored", "disabled", "label", "labelPosition", "className", "type"]);
    const classList = classNames("tecma-radioButton", { checked }, { [`${color}`]: color }, { [`${size}`]: size }, { [`${type}`]: type }, { [`${labelPosition}`]: labelPosition }, { errored }, { disabled }, className);
    return (_jsxs("div", Object.assign({ className: classList, onClick: onChange, "aria-label": "radioButton", onKeyDown: onChange, role: "button", tabIndex: 0 }, rest, { children: [type === "radio-card" && checked && _jsx(Icon, { iconName: "check", size: size }), type !== "radio-card" && (_jsx("div", { className: "radioButton-container", children: _jsx("div", { className: "radioButton-element" }) })), _jsx("span", { className: "radioButton-content", children: label })] })));
};
RadioButton.defaultProps = defaultProps;
/**
 * Radio buttons allow a user to select a single option from a list of predefined options.
 * @deprecated use `RadioGroup` and `Radio` instead
 */
export default React.memo(RadioButton);
